import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import ChallengeRanking from './ChallengeRanking'
import { getActivityView, getUserGoal } from '../Activity/store/ActivitySelectors'
import { cancelGetChallengesWithProgress, getCurrentCompanyGoal } from '../Activity/store/ActivityActions'
import { resetManualEntryInProgress } from '../Progress/store/ProgressActions'

const mapStateToProps = (state: IGlobalState, ownProps: any) => {
  const goalId = ownProps.match.params.goalId
  const token = ownProps.match.params.token || null
  //const isLegacyRanking = !(ownProps.match.path === '/challenges/:goalId/ranking' || token)
  const isLegacyRanking = ownProps.match.path === '/challenges/:goalId/ranking'
  return {
    goalId,
    token,
    goal: getUserGoal(state, goalId),
    isLegacyRanking,
    activityView: getActivityView(state, goalId),
  }
}

const mapDispatchToProps = {
  getCurrentCompanyGoal,
  cancelGetChallengesWithProgress,
  resetManualEntryInProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeRanking)
